import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PutCsvExcelAccountsRequestModel, PutCsvExcelAccountsResponseModel } from "@/features/accounts/csv-excel/services/put-accounts-model";

export class PutCsvExcelAccountsApi {
  /**
   * CsvExcel更新API
   */
  public putCsvExcelAccounts = async (
    param: PutCsvExcelAccountsRequestModel
  ): Promise<PutCsvExcelAccountsResponseModel> => {
    const path = `/api/csvexcelaccounts`;
    const res = await ApiClient.instance.put<PutCsvExcelAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
